// extracted by mini-css-extract-plugin
export default {"container":"app-loader_container__MERV3","loader":"app-loader_loader__MU0nk"};